import type { Control, FieldValues } from 'react-hook-form';
import { parseDate } from '../../../common/functions/parse-date';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { OdinCalendarProps } from './calendar.component';
import OdinCalendar from './calendar.component';

export interface HfDateProps<TFieldValues extends FieldValues = FieldValues> extends OdinCalendarProps {
  control: Control<TFieldValues>;
  name: string;
}

export default function HfDate<TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  readOnly,
  required,
  onChange,
  fieldValueConverter,
  disabled,
  fieldValidations,
  labelStyles,
  dateFormat,
}: HfDateProps<TFieldValues>) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange: handleChange, value: rawValue }, fieldState: { error } }) => {
        const value = rawValue as Date | string | null;
        return (
          <OdinCalendar
            label={label}
            value={value instanceof Date ? value : parseDate(value)}
            error={error?.message}
            onChange={handleChange}
            readOnly={disabled || readOnly}
            required={required}
            labelStyles={labelStyles}
            fieldValidations={fieldValidations}
            dateFormat={dateFormat}
            showButtonBar
          />
        );
      }}
    />
  );
}
